import './scss/index.scss'
import React, { useEffect, useRef, useState } from 'react'
import ReactDOM from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import { SoftShadows, View } from '@react-three/drei'
import { ReactLenis, useLenis } from 'lenis/react'

import Experience from './Experience.jsx'
import LoaderScreen from './LoaderScreen.jsx'
import GyroLogger from "./tools/GyroLogger"


function App() {
    const container = useRef()

    return (
        <>
            <ReactLenis root />
            <div className="container" ref={container}>
                <Experience />
                <Canvas
                    style={{ position: 'fixed', top: 0, bottom: 0, left: 0, right: 0, overflow: 'hidden' }}
                    // shadows
                    eventSource={container}
                    eventPrefix="client"
                    gl={{ powerPreference: 'high-performance', antialias: true }}
                    
                    dpr={[1, 1]}

                >
                    {/* <SoftShadows size={10} samples={60} focus={50} /> */}
                    <View.Port />
                </Canvas>
                <LoaderScreen />
            </div >
        </>
    )
}


const root = ReactDOM.createRoot(document.querySelector('#root'))
root.render(<App />)
